// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__htcuW","layout":"Layout_layout__hdige","bg_color":"Layout_bg_color__kEJ8q"};